// yyyy-MM-dd hh:mm:ss
export const currentDateTime = () => {
  const currentDateTime = new Date()
  const year = currentDateTime.getFullYear()
  const month = ('0' + (currentDateTime.getMonth() + 1)).slice(-2)
  const day = ('0' + currentDateTime.getDate()).slice(-2)
  const hours = ('0' + currentDateTime.getHours()).slice(-2)
  const minutes = ('0' + currentDateTime.getMinutes()).slice(-2)
  const seconds = ('0' + currentDateTime.getSeconds()).slice(-2)
  const formattedDateTime =
    year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
  return formattedDateTime
}

// yyyy-MM-dd
export const currentDate = (daysPast, dayMonthYear) => {
  const currentDateTime = new Date()
  currentDateTime.setDate(currentDateTime.getDate() + daysPast)
  const year = currentDateTime.getFullYear()
  const month = ('0' + (currentDateTime.getMonth() + 1)).slice(-2)
  const day = ('0' + currentDateTime.getDate()).slice(-2)
  const formattedDateTime = dayMonthYear
    ? day + '/' + month + '/' + year
    : year + '-' + month + '-' + day
  return formattedDateTime
}

// yyyy-MM-dd to Thu Jun 29 2023 00:00:00 GMT-0300 (Brasilia Standard Time)
export const currentDateTimeDescriptive = (daysPast) => {
  const currentDateTime = new Date()
  currentDateTime.setDate(currentDateTime.getDate() + daysPast)
  const year = currentDateTime.getFullYear()
  const month = ('0' + (currentDateTime.getMonth() + 1)).slice(-2)
  const day = ('0' + currentDateTime.getDate()).slice(-2)
  const formattedDateTime = year + '-' + month + '-' + day

  const formattedDate = new Date(formattedDateTime)
  return formattedDate
}

// Thu Jun 29 2023 00:00:00 GMT-0300 (Brasilia Standard Time) to yyyy-MM-dd
export const currentDateTimeToDatabase = (dateString) => {
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const formattedDate = `${year}-${month}-${day}`
  return formattedDate
}

// Convert dd/MM/yyyy to Timestamp
export const convertToTimestamp = (dateString) => {
  const parts = dateString.split('/')
  const formattedDate = parts[1] + '/' + parts[0] + '/' + parts[2]
  const timestamp = new Date(formattedDate).getTime() / 1000 // divide by 1000 to get the timestamp in seconds
  return timestamp
}

// 2023-07-24T11:51:28.243 to dd/MM/yyyy
export const convertToBrazilianDate = (dateString) => {
  const dateObj = new Date(dateString)
  const day = dateObj.getDate().toString().padStart(2, '0')
  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
  const year = dateObj.getFullYear().toString()
  const formattedDate = `${day}/${month}/${year}`
  return formattedDate
}

// Convert dd/MM/yyyy to yyyy-MM-dd
export const convertDateBarToDatabase = (dateString) => {
  const [day, month, year] = dateString.split('/')
  const formattedDate = `${year}-${month}-${day}`
  return formattedDate
}

// Calculate time difference in seconds
export const calculateTimeLeft = (dateTime) => {
  const givenDateTime = new Date(dateTime)
  const currentDateTime = new Date()
  const timeDifferenceInMilliseconds = currentDateTime - givenDateTime
  const timeDifferenceInSeconds = (60 - timeDifferenceInMilliseconds / 1000).toString().split('.')
  const secondsRemaining = timeDifferenceInSeconds[0]

  return secondsRemaining
}
